import { Controller } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['venue', 'autocomplete', 'zipCode', 'city', 'state'];

  populateAddressFields() {
    if (!this.hasAutocompleteTarget || !this.hasZipCodeTarget || !this.hasCityTarget || !this.hasStateTarget) return;

    Rails.ajax({
      url: `/venues/${this.venueTarget.value}.json`,
      type: 'GET',
      dataType: 'json',
      success: (data) => {
        if (data.city) {
          this.cityTarget.value = data.city;
        }
        if (data.state) {
          this.stateTarget.value = data.state;
        }
        if (data.zip_code) {
          this.zipCodeTarget.value = data.zip_code;
        }
        if (data.address) {
          this.autocompleteTarget.value = data.address;
        }
      },
    });
  }
}
